import { render } from "./IconFlag.vue?vue&type=template&id=5f18a7b2"
import script from "./IconFlag.vue?vue&type=script&lang=js"
export * from "./IconFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__